import LeaveReasonMasterActionTypes from './LeaveReasonMaster.types';

/** ****************************** LEAVE REASON MASTER *********************** */
export const leaveReasonMasterStart = () => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_START,
});

export const leaveReasonMasterSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_SUCCESS,
	payload: data,
});

export const leaveReasonMasterFailure = (error: any) => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_FAILURE,
	payload: error,
});

export const leaveReasonMasterResponseChanged = (data: any) => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_RESPONSE_CHANGED,
	payload: data,
});

export const leaveReasonMasterResponseRestStart = () => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_RESPONSE_REST_START,
});

export const leaveReasonMasterResponseRestSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS,
	payload: data,
});
export const updateLeaveReasonMasterStart = (data: any) => ({
	type: LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_START,
	payload: data,
});
export const updateLeaveReasonMasterSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_SUCCESS,
	payload: data,
});
export const updateLeaveReasonMasterFailure = (error: any) => ({
	type: LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_FAILURE,
	payload: error,
});
export const updateLeaveReasonMasterResponseRestStart = () => ({
	type: LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_START,
});
export const updateLeaveReasonMasterResponseRestSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS,
	payload: data,
});
export const addLeaveReasonMasterStart = (data: any) => ({
	type: LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_START,
	payload: data,
});
export const addLeaveReasonMasterSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_SUCCESS,
	payload: data,
});
export const addLeaveReasonMasterFailure = (error: any) => ({
	type: LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_FAILURE,
	payload: error,
});
export const addLeaveReasonMasterResponseRestStart = () => ({
	type: LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_RESPONSE_REST_START,
});
export const addLeaveReasonMasterResponseRestSuccess = (data: any) => ({
	type: LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS,
	payload: data,
});
